import classnames from 'classnames';
import React from 'react';

import ExpandableText from '@cineamo/ui/src/misc/ExpandableText';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

type MovieOverviewProps = {
    overview: string;
    className?: string;
    maxLines?: number;
};

const MovieOverview: React.FC<MovieOverviewProps> = ({ overview, className, maxLines = 5 }) => {
    const { track } = useAnalytics();
    function onExpandOverview() {
        track('Movie Overview Text Expanded');
    }
    if (!overview || overview.length === 0) return null;
    return (
        <ExpandableText
            className={classnames('pointer-events-auto', className)}
            classNameButton="text-[var(--primary-color)] underline italic font-bold !opacity-100"
            maxLines={maxLines}
            text={overview}
            onClick={onExpandOverview}
            initiallyExpanded={false}
            expandOnTextClick={true}
        />
    );
};

export default MovieOverview;
